import * as api from '../../resources/dictionaries.api';
import actionTypes from './dictionaries.action-types';

export const fetchLotteryTermsDictionaryRequest = () => ({
  type: actionTypes.FETCH_LOTTERY_TERMS_DICTIONARY_REQUEST,
});

export const fetchLotteryTermsDictionarySuccess = (terms) => ({
  type: actionTypes.FETCH_LOTTERY_TERMS_DICTIONARY_SUCCESS,
  terms,
});

export const fetchLotteryTermsDictionaryFailure = () => ({
  type: actionTypes.FETCH_LOTTERY_TERMS_DICTIONARY_FAILURE,
});

export const fetchLotteryTermsDictionary = () => async (dispatch) => {
  try {
    dispatch(fetchLotteryTermsDictionaryRequest());

    const terms = await api.fetchLotteryTermsDictionary();
    dispatch(fetchLotteryTermsDictionarySuccess(terms));
  } catch (error) {
    console.error('FETCH_LOTTERY_TERMS_DICTIONARY', error);
    dispatch(fetchLotteryTermsDictionaryFailure());
  }
};



// WEBPACK FOOTER //
// ./src/modules/app/actions/dictionaries/lottery-terms-dictionary.actions.js